import React from 'react';
import { styled } from 'baseui';
import { HeadingXSmall, ParagraphMedium } from 'baseui/typography';
type Props = {
  icon: React.ReactNode;
  title: string;
  description: string;
  actionButton?: React.ReactNode;
};
const Container = styled('section', ({
  $theme
}) => ({
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: $theme.sizing.scale300
}));
const StyledHeading = styled(HeadingXSmall, ({
  $theme
}) => ({
  margin: 0,
  marginTop: $theme.sizing.scale500,
  marginBottom: `-${$theme.sizing.scale100}`
}));
const StyledParagraph = styled(ParagraphMedium, ({
  $theme
}) => ({
  margin: 0,
  textAlign: 'center',
  paddingBottom: $theme.sizing.scale500
}));
export const PanelStateRenderer = ({
  icon,
  title,
  description,
  actionButton
}: Props) => {
  return <Container>
      {icon}
      <StyledHeading>{title}</StyledHeading>
      <StyledParagraph>{description}</StyledParagraph>
      {actionButton && actionButton}
    </Container>;
};